module.exports = __webpack_public_path__ + "img/portal.157ec7e.webp";